import { FaLinkedin } from "react-icons/fa";
import { BiChevronRight } from "react-icons/bi";
import { IoLogoYoutube } from "react-icons/io5";
import { FaEarthAsia } from "react-icons/fa6";
import { Link } from "react-router-dom";

function Footer({ setSelectedTab }) {
  const handleChange = (data) => {
    setSelectedTab(data);
  };
  const tabs = [
    "Retail",
    "Transportation",
    "Occupational Safety",
    "Warehousing",
    "Face Recognition",
  ];
  return (
    <footer id="footer" className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-5 col-md-12 footer-info">
              <div className=" d-flex">
                <a href="#hero">
                  <img
                    src="../../assets/newLogo2.png"
                    alt="Logo"
                    className="dark:invert"
                    width={100}
                    height={60}
                    priority
                    style={{ objectFit: "contain" }}
                  />
                </a>
              </div>

              <p>
                Pratham breaks the barriers of traditional analytics. Say
                goodbye to complex coding and cumbersome interfaces. With
                Pratham, no code is required, opening a world of possibilities
                for every user, regardless of their technical expertise.
              </p>
              <div>
              <div className="social-links mt-3">
                <a
                  href="https://www.youtube.com/@assertai"
                  className="facebook"
                  target="_"
                >
                  <IoLogoYoutube />
                </a>

                <a
                  href="https://www.linkedin.com/company/assert-ai"
                  className="linkedin"
                  target="_"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.assertai.com"
                  className="instagram"
                  target="_"
                >
                  <FaEarthAsia />
                </a>

                <a
                  href="https://www.producthunt.com/posts/pratham?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-pratham"
                  target="_blank1"
                >
                  <img
                    style={{ width: "150px" }}
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=441512&theme=neutral"
                    alt="Pratham - Empowering&#0032;You&#0032;with&#0032;Vision&#0032;AI&#0032;Insights | Product Hunt"
                  />
                </a>
              </div>
              </div>
              
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <BiChevronRight /> <a href="#hero">Home</a>
                </li>
                <li>
                  <BiChevronRight />
                  <a href="#usecase">Usecases</a>
                </li>
                <li>
                  <BiChevronRight />
                  <a href="#about">About us</a>
                </li>
                <li>
                  <BiChevronRight />
                  <Link to="terms">Terms & Conditions</Link>
                </li>
                <li>
                  <BiChevronRight />
                  <Link to="disclaimer">Disclaimer</Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4>Our Usecases</h4>
              <ul>
                {tabs.map((item, i) => (
                  <li key={i}>
                    <BiChevronRight />
                    <a href="#usecase" onClick={() => handleChange(item)}>
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
              <h4>Contact Us</h4>
              <p>
                Assert AI
                <br />
                303, A-Wing, Kanakia Zillion, LBS Marg, <br /> Kurla West,
                Mumbai <br /> 400070 <br />
                <strong>Phone:</strong> +91-8657-009634
                <br />
                <strong>Email:</strong> info@assertai.com
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>Pratham</span>
          </strong>
          . All Rights Reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
